"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = exports.DangerButton = exports.DefaultButton = exports.PrimaryButton = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/styles");
var Button_1 = tslib_1.__importDefault(require("@material-ui/core/Button"));
var colors_1 = require("@material-ui/core/colors");
var useStyles = styles_1.makeStyles({
    Wrap: {
        width: "100%",
        height: 44,
    },
    LinkButton: {
        color: "rgb(107, 138, 214)",
        textDecoration: "none",
        cursor: "pointer",
        fontWeight: 500,
    },
    PrimaryButton: function (newType) { return ({
        color: "rgb(255,255,255)",
        width: newType.width,
        backgroundColor: "rgb(115,139,216)",
        "&:hover": {
            backgroundColor: "rgb(104,125,194)",
        },
    }); },
    DefaultButton: function (newType) { return ({
        color: "rgb(115,139,216)",
        width: newType.width,
        borderColor: "rgb(115,139,216)",
        "&:hover": {
            color: "rgb(104,125,194)",
            borderColor: "rgb(104,125,194)",
        },
    }); },
    DangerButton: function (newType) { return ({
        color: colors_1.red[500],
        borderColor: colors_1.red[500],
        width: newType.width,
        "&:hover": {
            color: colors_1.red[700],
            borderColor: colors_1.red[700],
        },
    }); },
});
function PrimaryButton(props) {
    var children = props.children, onClick = props.onClick, block = props.block, other = tslib_1.__rest(props, ["children", "onClick", "block"]);
    var newType = { width: block ? "100%" : "" };
    var classes = useStyles(newType);
    return (React.createElement("div", null,
        React.createElement(Button_1.default, tslib_1.__assign({ className: classes.PrimaryButton, onClick: onClick }, other), children)));
}
exports.PrimaryButton = PrimaryButton;
function DefaultButton(props) {
    var children = props.children, onClick = props.onClick, block = props.block, other = tslib_1.__rest(props, ["children", "onClick", "block"]);
    var newType = { width: block ? "100%" : "" };
    var classes = useStyles(newType);
    return (React.createElement("div", null,
        React.createElement(Button_1.default, tslib_1.__assign({ variant: "outlined", className: classes.DefaultButton, onClick: onClick }, other), children)));
}
exports.DefaultButton = DefaultButton;
function DangerButton(props) {
    var children = props.children, onClick = props.onClick, block = props.block, other = tslib_1.__rest(props, ["children", "onClick", "block"]);
    var newType = { width: block ? "100%" : "" };
    var classes = useStyles(newType);
    return (React.createElement("div", null,
        React.createElement(Button_1.default, tslib_1.__assign({ variant: "outlined", className: classes.DangerButton, onClick: onClick }, other), children)));
}
exports.DangerButton = DangerButton;
function LinkButton(props) {
    var children = props.children, href = props.href, other = tslib_1.__rest(props, ["children", "href"]);
    var classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("a", tslib_1.__assign({ className: classes.LinkButton, href: href }, other), children)));
}
exports.LinkButton = LinkButton;
//# sourceMappingURL=ButtonWrap.js.map